import {
  ICheckExistSaleTeamRoute,
  ICreateSaleTeamRoute,
  IUpdateSaleTeamRoute,
} from 'apis/SaleLineTeamApis';
import {
  IGetAllRouteByTeamSaleInPlant,
  IGetAllTeamSaleByPlant,
} from 'interfaces/TeamSale/TeamSale';

export const SaleLineTeam_VARIABLE = {
  getListSaleLineTeam: (params: any) => {
    const { page, page_size, input } = params;
    return {
      skip: (page - 1) * page_size,
      take: page_size,
      input,
    };
  },
  updateSalelineTeam: (data: any) => {
    return { data: data };
  },
  checkExistSaleTeamInRoute: (routeId: string) => {
    return {
      input: {
        routeId: {
          equals: routeId,
        },
      },
    };
  },
  createSaleTeamRoute: (params: ICreateSaleTeamRoute) => ({ data: params }),
  checkExistSaleTeamRoute: (params: ICheckExistSaleTeamRoute) => {
    const useYn = params.useYn;

    return {
      input: {
        routeId: { equals: params.routeId },
        teamSalesId: { equals: params.teamSalesId },
        ...(useYn && { useYn: { equals: useYn } }),
      },
    };
  },
  updateManySalelineTeam: (data: IUpdateSaleTeamRoute[]) => {
    return { input: data };
  },
  getAllTeamSaleByPlant: ({
    plantId,
    skip,
    take,
    search,
  }: IGetAllTeamSaleByPlant) => {
    return {
      skip,
      take,
      input: {
        plantId: plantId,
        keySearch: search,
      },
    };
  },
  getAllRouteByTeamSaleInPlant: ({
    plantId,
    skip,
    take,
    teamSalesId,
    search,
  }: IGetAllRouteByTeamSaleInPlant) => {
    return {
      skip,
      take,
      input: {
        plantId: {
          equals: plantId,
        },
        teamSalesId: {
          equals: teamSalesId,
        },
        troute: {
          OR: search
            ? [
                {
                  name: {
                    contains: search,
                  },
                },
                {
                  id: {
                    contains: search,
                  },
                },
              ]
            : [],
        },
        useYn: {
          equals: true,
        },
      },
    };
  },
};
